import { SwgCampaignOfferValues } from '../campaigns'
import { getDefaultRrmeCampaignValues } from './RrmeDefaultOfferCampaign'
import { getUniversityOfferRrmeCampaignValues } from './RrmeUniOfferCampaign'

const validRrmeCampaignOffers = ['university-offer', 'annual-package'] as const

export type RrmeCampaignOffer = typeof validRrmeCampaignOffers[number]

/**
 * Return if the provided campaign offer (from LaunchDarkly feature 'swg-campaign-offer')
 * is valid for the current environment.
 */
export const isRrmeCampaignOfferValid = (
    campaignOffer: string | undefined,
): boolean => {
    if (!campaignOffer) {
        return false
    }

    return validRrmeCampaignOffers.includes(campaignOffer as RrmeCampaignOffer)
}

export const getRrmeCampaignOfferValues = (
    campaignOffer: RrmeCampaignOffer,
): SwgCampaignOfferValues => {
    switch (campaignOffer) {
        case 'university-offer':
            return getUniversityOfferRrmeCampaignValues()
        // annual-package handling is included in default case
        case 'annual-package':
        default:
            return getDefaultRrmeCampaignValues()
    }
}
